import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  title?: string
  description?: string | React.FC | ReactNode
  list?: string[]
  primaryLabel?: string
  secondaryLabel?: string | false

  onPrimaryClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onSecondaryClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export const InformationModal: BaseModalType<Props> = (props) => {
  const { close, primaryLabel, list, onSecondaryClick, onPrimaryClick } = props
  const { t } = useTranslation()
  const { title } = props
  const { secondaryLabel = t('OK') } = props
  const { description: Description } = props

  const text = Description ? (
    typeof Description === 'function' ? (
      <Description />
    ) : (
      Description
    )
  ) : undefined

  return (
    <Modal>
      {title && <Modal.Header>{title}</Modal.Header>}
      <Modal.Body>
        {text && <Modal.Body.Text>{text}</Modal.Body.Text>}
        {list?.length && (
          <Modal.Body.List>
            {list.map((item, index) => (
              <Modal.Body.List.Item key={index}>{item}</Modal.Body.List.Item>
            ))}
          </Modal.Body.List>
        )}
      </Modal.Body>
      <Modal.Footer>
        {secondaryLabel && (
          <Modal.Footer.Secondary onClick={onSecondaryClick ?? close}>
            {secondaryLabel}
          </Modal.Footer.Secondary>
        )}
        {primaryLabel && (
          <Modal.Footer.Primary onClick={onPrimaryClick}>{primaryLabel}</Modal.Footer.Primary>
        )}
      </Modal.Footer>
    </Modal>
  )
}
